function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.1 9.2c3 .6 5.6-2 5-5-.3-1.7-1.7-3-3.3-3.3-3-.6-5.6 2-5 5 .3 1.6 1.7 3 3.3 3.3zM10 11.7c2.9 0 8.3 1.9 9.5 5.7l.2 1.3v1.8c0 .5-.4.9-.9.9H1.2c-.5 0-.9-.4-.9-.9v-1.8l.2-1.3c1.2-3.8 6.5-5.7 9.5-5.7"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22"
  }, props), _ref);
};

export default SvgComponent;